import Vue from 'vue'
import BillingMobileRechargesService from 'js/services/api/billing/mobile-recharges.js'
import BillingProductRechargesService from 'js/services/api/passenger/productsByCard.js'

import RechargeMixin from 'js/pages/recharge/_recharge-mixin.js'
import BasicData from 'js/pages/recharge/_basic-data.js'
import RechargeData from 'js/pages/recharge/_recharge-data.js'
import BuyerRegistryForm from 'js/pages/recharge/_buyer-registry-form.js'
import PaymentGateway from 'js/pages/recharge/_payment-gateway.js'
import PaymentConfirm from 'js/pages/recharge/_payment-confirm.js'
import RechargeFree from './_recharge-free'
import {DEFAULT_MEDIA_TYPE} from 'js/pages/recharge/config.js'

import template from 'js/pages/recharge/index.pug'

export default Vue.extend({
  name: 'topup-page',
  template: template(),
  components: {
    BasicData,
    RechargeData,
    BuyerRegistryForm,
    PaymentGateway,
    PaymentConfirm,
    RechargeFree
  },

  mixins: [RechargeMixin],
  data() {
    const vm = this

    return {
      products: [],
      productErrors: {},
      cardResponse: false,
      web_title: Vue.store.state.webTitle,
      // Secciones
      selectedSection: undefined,
      // Datos de entrada
      formData: vm.defaultFormData(),
      // Recarga
      rechargeData: vm.defaultRechargeData(),
      checkRechargeInterval: undefined,
      formDataReady: false,
      scriptAttrs: {},
      formAttrs: {},
      dataBrands: undefined,
      titleAlt:"",
    }
  },

  computed: {
    emailIsNecessary() {
      return !this.formData.is_nominal_recharge
    },
    billingRequired() {
      return this.currentAppConfig.billing_required
    },
    steps() {
      
      const tAlt = this.$t('recharge.title').split(">")
      const tAlt2 = tAlt[1].split("<")
      const tAlt3 = tAlt[2].split("<")
      this.titleAlt = tAlt2[0] + " " + tAlt3[0] 
      
      if (this.billingRequired) {
        return [
          { id: 0, text: this.$t('recharge.basicData.sectionTitle') },
          { id: 1, text: this.$t('recharge.rechargeData.sectionTitle') },
          { id: 2, text: this.$t('recharge.buyerRegistryForm.title') },
          { id: 3, text: this.$t('recharge.paymentGateway.sectionTitle') }
        ]
      }
      return [
        { id: 0, text: this.$t('recharge.basicData.sectionTitle') },
        { id: 1, text: this.$t('recharge.rechargeData.sectionTitle') },
        { id: 3, text: this.$t('recharge.paymentGateway.sectionTitle') }
      ]
    },
    currentStepId() {
      if (this.selectedSection === 4) {
        return 3
      }
      return this.selectedSection
    }
  },
  watch: {
    administrativeArea() {
      this.setAdministrativeAreaId()
    },

    $municipality: {
      handler() { this.formData.municipality_id = this.$municipality.id },
      immediate: true
    }
  },
  created() {
    const vm = this
    // Se ha entrado a ver una recarga en particular
    if (vm.$route.query.recharge_id) {
      vm.getRecharge(vm.$route.query.recharge_id, false)
      vm.initCheckRecharge(vm.$route.query.recharge_id)

      // Se entra al paso 2 directamente
    } else if (_.includes(['municipality-recharge-data', 'recharge-data'], this.$route.name)) {
      this.calculateRechargeDataStep(this.$route.params)
      this.setAdministrativeAreaId()
    } else {
      vm.selectedSection = 0
      vm.resetView()
    }
  },
  destroy() {
    clearInterval(this.checkRechargeInterval)
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.checkRechargeInterval)
    next()
  },
  beforeRouteUpdate(to, from, next) {
    const vm = this
    if (_.includes(['municipality-recharge', 'recharge'], to.name) && _.isEmpty(to.query)) {
      vm.retry()
    }
    next()
  },
  methods: {
    updateProducts(products) {
      this.products = products
    },

    setAdministrativeAreaId() {
      if (!this.formData.administrative_area_id && this.administrativeArea) {
        this.formData.administrative_area_id = this.administrativeArea.id
        this.formData.administrative_area_code = this.administrativeArea.code
      }
    },
    /*
     * Calcula el paso 2 con datos desde la ruta
     */
    calculateRechargeDataStep(params) {
      this.formData.media_type = params.media_type
      this.formData.media_code = params.media_code
      this.formData.is_nominal_recharge = true
      this.selectedSection = 1
    },

    /*
     * Comprueba el estado de la recarga
     */
    getRecharge(id, skipLoading) {
      let rechargeTarget = null
      // identificador si es recarga de saldo o de producto
      if (this.cardResponse === 'true') {
        rechargeTarget = BillingProductRechargesService
      } else {
        rechargeTarget = BillingMobileRechargesService
      }

      rechargeTarget.show(id, {skipLoading}).then(response => {
        this.$set(this, 'rechargeData', _.assign(this.rechargeData, response))
        // Proceso acabado con éxito
        if (
          this.rechargeData.state === 'success_notified' || this.rechargeData.state === 'queued'
        ) {
          localStorage.removeItem('tokenRedsys')
          this.selectedSection = 4
          clearInterval(this.checkRechargeInterval)
        } else if (_.includes(['admited', 'waiting_confirmation'], this.rechargeData.state)) {
          this.goPaymentPlatform(this.dataBrands)

          // Resto de estados
        } else {
          if (_.includes(['failed_notified', 'erroneous', 'cancelled'], this.rechargeData.state)) {
            localStorage.removeItem('tokenRedsys')
            clearInterval(this.checkRechargeInterval)
          }
          this.selectedSection = 3
        }
      }, () => {
        clearInterval(this.checkRechargeInterval)
      })
    },
    /*
     * Valida producto seleccionado
     */
    validateProductRequest(data, dataBrands) {
      this.productErrors = {}
      const params = {type: 'recharge', origin: 'passenger_app', ...this.formData}
      const productRechargeParams = this.dataProductRecharge(params)
      
      BillingProductRechargesService.productValidate({...productRechargeParams}).then(() => {
          this.goToRechargeDataNextStep(data, dataBrands)
      }).catch(
        response => {
          this.productErrors = response.data.errors
        }
      )
    },

    /*
     * Crea una recarga
     */
    createRecharge() {
      const vm = this
      let rechargeTarget = null
      let setParams = null
      const params = {type: 'recharge', origin: 'passenger_app', ...this.formData}
      this.cardResponse = localStorage.getItem('cardResponse')

      if (this.dataBrands === 'REDSYS') {
        params.gateway = 'redsys'
      }

      if (this.dataBrands === 'PAYSTORE') {
        params.gateway = 'paystore'
      }

      // Identificador si es recarga de saldo o de producto
      if (this.cardResponse === 'true') {
        rechargeTarget = BillingProductRechargesService
        const productRechargeParams = this.dataProductRecharge(params)
        productRechargeParams.origin = params.origin
        productRechargeParams.gateway = params.gateway
        productRechargeParams.email = params.email
        setParams = {...productRechargeParams}
      } else {
        rechargeTarget = BillingMobileRechargesService
        setParams = {data: params}
      }

      rechargeTarget.create(setParams).then(response => {
        vm.$set(vm, 'rechargeData', _.assign(vm.rechargeData, response))
        localStorage.setItem('rechargeDataS', (JSON.stringify(response)))
        vm.selectedSection = 3
        vm.resetView()
        vm.initCheckRecharge(vm.rechargeData.id)
      }).catch(response => {
        if (this.cardResponse === 'true') {
          localStorage.setItem('productErrors', (JSON.stringify(response.data.errors)))
        }
      })
    },

    /*
     * Create a top-up when the amount is zero.
        Only for product refill
     */
    async createRechargeWithZeroAmount() {
      const vm = this
      this.cardResponse = localStorage.getItem('cardResponse')
      const params = {type: 'recharge', origin: 'passenger_app', ...this.formData}
      params.gateway = (this.dataBrands ?? '').toLowerCase();

      const productRechargeParams = this.dataProductRecharge(params)
      productRechargeParams.origin = params.origin
      productRechargeParams.gateway = params.gateway
      productRechargeParams.email = params.email
      productRechargeParams.compensation_center_id = this.administrativeArea?.compensation_center_id
      const setParams = {...productRechargeParams}

      await BillingProductRechargesService.create(setParams).then(response => {
        vm.$set(vm, 'rechargeData', _.assign(vm.rechargeData, response))
        localStorage.setItem('rechargeDataS', (JSON.stringify(response)))
        vm.selectedSection = 4
        vm.resetView()
        this.completeProductRecharge(response)
      }).catch(response => {
        if (this.cardResponse === 'true') {
          localStorage.setItem('productErrors', (JSON.stringify(response.data.errors)))
        }
      })
    },

    async completeProductRecharge(productRecharge){

      await BillingProductRechargesService.complete_product_recharge(productRecharge).then(response => {
        localStorage.setItem('rechargeDataS', (JSON.stringify(response)))
      }).catch(response => {
        if (this.cardResponse === 'true') {
          localStorage.setItem('productErrors', (JSON.stringify(response.data.errors)))
        }
      })
    },

    // Parametros necesarios para la recarga de productos
    dataProductRecharge(params) {
      return {
        support_instance_code: params.media_code,
        support_type: 1,
        product_instance_code: params.product_item_code,
        administrative_area_code: params.administrative_area_code,
        external_precharge_id: params.external_precharge_id,
        channel: 'ABC123',
        type: 16,
        operation_date_utc: moment().utc().format('YYMMDDHHmmss'),
        external_operation_id: '9876543210',
        tsc_data: {
          TF: {
            TFCT: '001',
            TFTT: '2',
            TFTF: '30.5',
            TFEP: 'EmpresaX',
            TFFT: 'FlagsX',
            TFFTS: '20240515',
            TFFV: '20240615',
            TFNP: 1,
            TFTP: 'Mensual',
            TFCF: 10,
            TFTU: '35.0',
            TFFU: '20240510'
          },
          FT: {
            FTNT: '1001',
            FTMA: 'MovActual',
            FTFTA: 'FlagsTarjeta',
            FTFTI: 'FlagTituloActivo',
            FTRF: 'Valido',
            FTCH: 'CopiaHist',
            FTRA: 'RegActuales',
            FTIDR: 'IDRecarga',
            FTFAR: '20240510',
            FTFUO: '20240515'
          },
          HV: {
            HVF: '20240515',
            HV1P: 'Parada1',
            HVVC: 'Vehiculo1',
            HVSF: 20.0,
            HVO: 'OperadorX'
          }
        },
        pv_id: 'PV1234',
        vendor_id: 'Vend001',
        estacion_f: 10,
        etm_f: 20,
        vestibulo_f: 30,
        serial_crypto_dev: 'SAM123456',
        device_code: 'DEV001',
        product_code: 2,
        fare_code: 1,
        buy_price: params.amount,
        fare_index: 3,
        validity_period: 12,
        recharge_amount: 1, // unidades de viajes recargadas
        period_type: 1,
        operation_date: moment().utc().format('YYYY-MM-DDTHH:mm:ssZ'),
        compensation_center_id: this.administrativeArea?.compensation_center_id
      }
    },

    /*
     * Inicializa el método para comprobar la recarga
     */
    initCheckRecharge(id) {
      const vm = this
      vm.checkRechargeInterval = setInterval(() => {
        vm.getRecharge(id, true)
      }, 2000)
    },

    /*
     * Reiniciar posición de la vista
     */
    resetView() {
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0 // Safari
    },
    goToStepOne(data) {
      const vm = this
      vm.$set(vm, 'formData', _.assign(vm.formData, data))
      vm.selectedSection = 1
      vm.resetView()
    },
    goToRechargeDataNextStep(data, dataBrands) {
      if (this.productErrors.length > 0) { return }

      this.$set(this, 'formData', _.assign(this.formData, data))
      this.$set(this, 'dataBrands', dataBrands)

      if (this.billingRequired) {
        this.selectedSection = 2
      } else {
        this.createRecharge()
      }
    },
    goToStepThree(buyerRegistryData = {}) {
      this.formData = {
        ...this.formData,
        ...buyerRegistryData
      }

      if(this.formData.amount !== 0 ){
        this.createRecharge()
      }else{
        this.createRechargeWithZeroAmount()
      }
    },
    goBackStepZero() {
      const vm = this
      vm.selectedSection = 0
      vm.$set(
        vm,
        'formData',
        _.assign(vm.formData, { amount: 500, email: undefined, accept_conditions: false })
      )
      vm.resetView()
    },
    defaultFormData() {
      return {
        administrative_area_code: undefined,
        media_type: DEFAULT_MEDIA_TYPE,
        media_code: undefined,
        amount: 500,
        email: undefined,
        accept_conditions: false,
        is_nominal_recharge: true
      }
    },
    defaultRechargeData() {
      return {
        amount: undefined,
        bonus_amount: undefined,
        buy_order: undefined,
        media_code: undefined,
        media_type: undefined,
        pay_url: undefined,
        retries: undefined,
        state: undefined,
        token: undefined,
        trans_date: undefined,
        id: undefined,
        administrative_area_name: undefined
      }
    },
    goToStepZeroWithValue(formData) {
      const vm = this

      vm.selectedSection = 0
      vm.formData = formData

      clearInterval(vm.checkRechargeInterval)
      vm.$router.push({ name: vm.$route.name })

      vm.resetView()
    },
    retry() {
      const vm = this
      vm.selectedSection = 0
      vm.rechargeData = vm.defaultRechargeData()
      clearInterval(vm.checkRechargeInterval)

      vm.resetView()
    },
    applyContrasteCss(){
      // console.log(`applying high contrast for component ${this.$options.name} (${this.contraste})`)

      if(this.contraste){
        $(".ns-layout ,.ns-layout__header, .text-black , .text-gray2 , .sidepanel-map__card--item__stop--route , .sidepanel-map__card--item__stop ,.flex-middle,.ns-layout__footer__footer").css("cssText" ," color: #ffffff !important")
        $(".ns-layout ,.ns-layout__header, .text-black , .text-gray2 , .sidepanel-map__card--item__stop--route , .sidepanel-map__card--item__stop").css("background-color" ,"#1e1e1e")
        $(".text-primary , .text-gray2-hover , .button-phone , .text-gray3 , .ns-layout__sidebar__map__menu").css("cssText" ," color: #ffffff !important")
        $(".text-primary , .text-gray2-hover , .button-phone , .text-gray3 ").css("background-color" ,"#1e1e1e")
        $("a ,.sidepanel-map__container, .recharge-home__recharges , .recharge-home__cities , .ns-layout__footer__items , .pb-d6 , .sidepanel-map__card--item__point-name").css("color" ,"#fff")
        $(".sidepanel-map__container, .recharge-home__recharges , .recharge-home__cities , .ns-layout__footer__items ,.pb-d6, .sidepanel-map__card--item__point-name,.flex-middle ,.sidepanel-map__header").css( "cssText" ,"background-color: #1e1e1e !important")
        $(".sidepanel-map--planner__form , .uppercase-vz ,.hidden-xs ,.panel,.ns-field__label,.uppercase ,#fares-side-menu,.flex-column").css("color" ,"#fff")
        $(".sidepanel-map--planner__form , .uppercase-vz ,.hidden-xs ,.panel,.ns-field__label,.uppercase ,#fares-side-menu,.flex-column").css("background-color" ,"#1e1e1e")
        $("label,.ns-tabs__item,.primay-dark,.text-small, .ns-icon-angle-right ,.h1-main-title,.text-main-title ").css("color" ,"#fff")
        $("label,.ns-tabs__item,.primay-dark,.text-small, .ns-icon-angle-right ,.h1-main-title,.text-main-title,.colorFondo ").css("background-color" ,"#1e1e1e")
        $(".ns-layout__header--city , .ns-button,.text-info , .ns-icon-youtube").css("color" ,"#1e1e1e");
        $(".ns-layout__header--city , .ns-button,.text-info , .ns-icon-youtube").css("background-color" ,"#fff")
        $(" .pb-d6 ").css("color" ,"#fff")  
        $("#iconorestablecer").css("color" ,"#1e1e1e");
        $("#iconorestablecer").css("background-color" ,"#fff")
        $("#textorestablecer").css("color" ,"#1e1e1e");
        $("#textorestablecer").css("background-color" ,"#fff")
        $(".text-gray2,.text-primary-hover ,.ns-layout__footer, .ns-layout__footer__footer,.hidden-cl ").css("cssText" ," color: #ffffff !important")
        $(".panel-schedules ,.px-d2 , .ns-session__nav--login ,.ns-layout__footer__footer").css( "cssText" ,"background-color: #1e1e1e !important")
        $(".ns-tabs ").css("background-color" ,"#1e1e1e")
        $("#linkhome ").css( "cssText" ,"color: #1e1e1e !important")
      
        $(".tablacss ").css( "cssText" ,"color: #1e1e1e !important")
        $(".tablacss ").css("background-color" ,"#fff")
        $(".ns-icon-angle-left,.sidepanel-map__card--item__stop ").css("color" ,"#fff")
        $(".ns-icon-angle-left ").css("background-color" ,"#1e1e1e")
        $("#linkhome ").css( "cssText" ,"color: #1e1e1e !important")
        $(".ns-layout__sidebar__map__menu").css("background-color" ,"#ffffff")
        $(".textomenu ").css( "cssText" ,"color: #1e1e1e !important")
        $("#linkhome ").css( "cssText" ,"color: #1e1e1e !important")
        $(".ns-layout__sidebar__map__menu").css("background-color" ,"#ffffff")
        $(".textomenu ").css( "cssText" ,"color: #1e1e1e !important")

        $(".submenuusuario").css("background-color" ,"#ffffff")
        $(".submenuusuario").css( "cssText" ,"color: #1e1e1e !important")

        $(".button-phone").css("border", "2px solid #ffffff")
        $(".option-menu").css("border", "none")
        $( ".active" ).css("background-color","transparent").css("border","2px solid #1e1e1e");
      }else{
        $(".ns-layout ,.ns-layout__header, .text-black , .text-gray2 , .sidepanel-map__card--item__stop--route , .sidepanel-map__card--item__stop").css("color" ,"")
        $(".ns-layout ,.ns-layout__header, .text-black , .text-gray2 , .sidepanel-map__card--item__stop--route , .sidepanel-map__card--item__stop").css("background-color" ,"")
        $(".text-primary , .text-gray2-hover , .button-phone , .text-gray3 , .ns-layout__sidebar__map__menu").css("color" ,"")
        $(".text-primary , .text-gray2-hover , .button-phone , .text-gray3 , .ns-layout__sidebar__map__menu").css("background-color" ,"")
        $("a ,.sidepanel-map__container, .recharge-home__recharges , .recharge-home__cities , .ns-layout__footer__items , .pb-d6 , .sidepanel-map__card--item__point-name").css("color" ,"")
        $(".sidepanel-map__container, .recharge-home__recharges , .recharge-home__cities , .ns-layout__footer__items ,.pb-d6, .sidepanel-map__card--item__point-name,.flex-middle ,.sidepanel-map__header").css( "background-color" ,"")
        $(".sidepanel-map--planner__form , .uppercase-vz ,.hidden-xs ,.panel,.ns-field__label,.uppercase ,#fares-side-menu,.flex-column").css("color" ,"")
        $(".sidepanel-map--planner__form , .uppercase-vz ,.hidden-xs ,.panel,.ns-field__label,.uppercase ,#fares-side-menu,.flex-column").css("background-color" ,"")
        $("label,.ns-tabs__item,.primay-dark,.text-small, .ns-icon-angle-right ,.h1-main-title,.text-main-title ").css("color" ,"")
        $("label,.ns-tabs__item,.primay-dark,.text-small, .ns-icon-angle-right ,.h1-main-title,.text-main-title,.ns-session__nav--login ").css("background-color" ,"")
        $(".ns-layout__header--city , .ns-button,.text-info , .ns-icon-youtube,.ns-tabs, .button-tabs,.text-primary-hover,.ns-layout__footer__footer,.hidden-cl").css("color" ,"");
        $(".ns-layout__header--city , .ns-button,.text-info , .ns-icon-youtube ,.mb-d1-2 ,.px-d2 ,.ns-tabs__item ,.panel-schedules ,.ns-tabs, .button-tabs,.ns-layout__footer__footer,.hidden-cl").css("background-color" ,"")
        $(" .pb-d6 ,.panel-schedules ,.px-d2 ").css("color" ,"")  
        $("#iconorestablecer").css("color" ,"#1e1e1e");
        $("#iconorestablecer").css("background-color" ,"#fff")
        $("#textorestablecer").css("color" ,"#1e1e1e");
        $("#textorestablecer").css("background-color" ,"#fff")
        $("#linkhome").css( "color" ,"")
        $(".textomenu").css( "color","")
        $(".tablacss ").css( "color","")
        $(".tablacss ").css("background-color" ,"")
        $(".ns-icon-angle-left ").css("color" ,"")
        $(".ns-icon-angle-left ,.colorFondo  ").css("background-color" ,"")
      }
    }
  }
})
